module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"review_button_title":"상세 리뷰 팝업 열기"}}')
  delete Component.options._Ctor
}
